const GOOGLE_ADS_SIGNUP_CONVERSION = "AW-882189406/ycZRCLuWquccEN7I1KQD"

type SignupMethod = "email" | "google"

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

const trackSignupConversion = (method: SignupMethod): void => {
  if (typeof window.gtag !== "function") return

  window.gtag("event", "sign_up", { method })
  window.gtag("event", "conversion", {
    send_to: GOOGLE_ADS_SIGNUP_CONVERSION,
    value: 1.0,
    currency: "INR"
  })
}

export { trackSignupConversion }
export type { SignupMethod }
